export interface Country {
  code: string;
  name: string;
  nameDE: string;
}

export const EU_EEA_COUNTRIES: Country[] = [
  { code: 'AT', name: 'Austria', nameDE: 'Österreich' },
  { code: 'BE', name: 'Belgium', nameDE: 'Belgien' },
  { code: 'BG', name: 'Bulgaria', nameDE: 'Bulgarien' },
  { code: 'HR', name: 'Croatia', nameDE: 'Kroatien' },
  { code: 'CY', name: 'Cyprus', nameDE: 'Zypern' },
  { code: 'CZ', name: 'Czech Republic', nameDE: 'Tschechien' },
  { code: 'DK', name: 'Denmark', nameDE: 'Dänemark' },
  { code: 'EE', name: 'Estonia', nameDE: 'Estland' },
  { code: 'FI', name: 'Finland', nameDE: 'Finnland' },
  { code: 'FR', name: 'France', nameDE: 'Frankreich' },
  { code: 'DE', name: 'Germany', nameDE: 'Deutschland' },
  { code: 'GR', name: 'Greece', nameDE: 'Griechenland' },
  { code: 'HU', name: 'Hungary', nameDE: 'Ungarn' },
  { code: 'IE', name: 'Ireland', nameDE: 'Irland' },
  { code: 'IT', name: 'Italy', nameDE: 'Italien' },
  { code: 'LV', name: 'Latvia', nameDE: 'Lettland' },
  { code: 'LT', name: 'Lithuania', nameDE: 'Litauen' },
  { code: 'LU', name: 'Luxembourg', nameDE: 'Luxemburg' },
  { code: 'MT', name: 'Malta', nameDE: 'Malta' },
  { code: 'NL', name: 'Netherlands', nameDE: 'Niederlande' },
  { code: 'PL', name: 'Poland', nameDE: 'Polen' },
  { code: 'PT', name: 'Portugal', nameDE: 'Portugal' },
  { code: 'RO', name: 'Romania', nameDE: 'Rumänien' },
  { code: 'SK', name: 'Slovakia', nameDE: 'Slowakei' },
  { code: 'SI', name: 'Slovenia', nameDE: 'Slowenien' },
  { code: 'ES', name: 'Spain', nameDE: 'Spanien' },
  { code: 'SE', name: 'Sweden', nameDE: 'Schweden' },
  // EEA countries (non-EU)
  { code: 'IS', name: 'Iceland', nameDE: 'Island' },
  { code: 'LI', name: 'Liechtenstein', nameDE: 'Liechtenstein' },
  { code: 'NO', name: 'Norway', nameDE: 'Norwegen' },
];

export const getCountryOptions = (locale: 'en' | 'de' = 'de') => {
  return EU_EEA_COUNTRIES.map(country => ({
    value: country.code,
    label: locale === 'de' ? country.nameDE : country.name
  }));
};

export const getCountryByCode = (code: string): Country | undefined => {
  return EU_EEA_COUNTRIES.find(country => country.code === code);
};

export const getCountryCodeByGermanName = (germanName: string): string | undefined => {
  const country = EU_EEA_COUNTRIES.find(country => country.nameDE === germanName);
  return country?.code;
};